module.exports = __webpack_public_path__ + "static/media/huanjing2.148a7bfd.png";